module.exports = __webpack_public_path__ + "static/media/Comfortaa-Bold.4b16b7a5.svg";